import { FilterField } from "types/filters";

export const getProjectFilters = async (
  projectId: string,
  baseUri: string,
): Promise<FilterField> => {
  try {
    const response = await fetch(
      `${baseUri}/v1/project-filters/${projectId}?tools[]=roomSelector`,
    );
    if (!response.ok) {
      throw new Error("error fetching project filters");
    }
    const parsedResponse = await response.json();
    return parsedResponse.data[0].fields;
  } catch (error) {
    console.error("error fetching project filters:", error);
    throw error;
  }
};
